/**
 * @generated SignedSource<<80a4d612b69c8de3aeb84a8333439291>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteMediaItemInput = {
  clientMutationId?: string | null | undefined;
  forceDelete?: boolean | null | undefined;
  id: string;
};
export type Media_DeleteMediaItem_Mutation$variables = {
  input: DeleteMediaItemInput;
};
export type Media_DeleteMediaItem_Mutation$data = {
  readonly deleteMediaItem: {
    readonly deletedId: string | null | undefined;
    readonly mediaItem: {
      readonly description: string | null | undefined;
      readonly id: string;
      readonly mediaDetails: {
        readonly sizes: ReadonlyArray<{
          readonly name: string | null | undefined;
          readonly sourceUrl: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly mediaItemUrl: string | null | undefined;
      readonly mimeType: string | null | undefined;
      readonly status: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Media_DeleteMediaItem_Mutation = {
  response: Media_DeleteMediaItem_Mutation$data;
  variables: Media_DeleteMediaItem_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaItem",
  "kind": "LinkedField",
  "name": "mediaItem",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaItemUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mimeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaDetails",
      "kind": "LinkedField",
      "name": "mediaDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MediaSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourceUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Media_DeleteMediaItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteMediaItemPayload",
        "kind": "LinkedField",
        "name": "deleteMediaItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Media_DeleteMediaItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteMediaItemPayload",
        "kind": "LinkedField",
        "name": "deleteMediaItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedId"
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8315e9810f588abeb31265339dd9816c",
    "id": null,
    "metadata": {},
    "name": "Media_DeleteMediaItem_Mutation",
    "operationKind": "mutation",
    "text": "mutation Media_DeleteMediaItem_Mutation(\n  $input: DeleteMediaItemInput!\n) {\n  deleteMediaItem(input: $input) {\n    deletedId\n    mediaItem {\n      id\n      status\n      mediaItemUrl\n      mimeType\n      mediaDetails {\n        sizes {\n          sourceUrl\n          name\n        }\n      }\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "16ac6fac4f2136bed6e81630e8518e62";

export default node;
